module.exports = __webpack_public_path__ + "img/check-circle.09daaf33.svg";